import React from 'react';
import { Star, Wrench, Rocket, BarChart3, Sparkles } from 'lucide-react';
import './ResumeScorerResults.css';

const ResumeScorerResults = ({ scorerResult, setScorerResult }) => {
  if (!scorerResult) return null;

  return (
    <div className="card scorer-results-card">
      <div className="scorer-header">
        <div className="score-display">
          <div className="score-value">{scorerResult.score}</div>
          <div className="score-label">Score</div>
          {scorerResult.creative_analysis?.persona && (
            <div className="persona-badge">{scorerResult.creative_analysis.persona}</div>
          )}
        </div>
        <div className="score-summary">
          <div className="industry-fit-box">
             <span className="industry-fit-label">Industry Fit:</span>
             <span className="industry-fit-value">{scorerResult.creative_analysis?.industry_fit || 'N/A'}%</span>
          </div>
          <h3>Analysis Summary</h3>
          <p>{scorerResult.summary}</p>
        </div>
      </div>

      {scorerResult.creative_analysis?.pro_tip && (
        <div className="pro-tip-card">
          <div className="pro-tip-header">
            <Sparkles size={16} className="sparkle" /> AI PRO-TIP
          </div>
          <p>{scorerResult.creative_analysis.pro_tip}</p>
        </div>
      )}

      {scorerResult.skill_map && (
        <div className="skill-map-section">
          <h4><BarChart3 size={20} style={{ verticalAlign: 'middle', marginRight: '8px' }} /> Skill Proficiency Map</h4>
          <div className="skill-grid">
            {scorerResult.skill_map.map((skill, i) => (
              <div key={i} className="skill-item">
                <div className="skill-info">
                  <span>{skill.category}</span>
                  <span>{skill.score}/10</span>
                </div>
                <div className="skill-bar-bg">
                  <div 
                    className="skill-bar-fill" 
                    style={{ width: `${(skill.score / 10) * 100}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      
      <div className="scorer-details">
        <div className="scorer-col">
          <h4><Star size={18} style={{ verticalAlign: 'middle', marginRight: '8px' }} /> Strengths</h4>
          <ul>
            {scorerResult.strengths.map((s, i) => <li key={i}>{s}</li>)}
          </ul>
        </div>
        <div className="scorer-col">
          <h4><Wrench size={18} style={{ verticalAlign: 'middle', marginRight: '8px' }} /> Improvements</h4>
          <ul className="improvement-list">
            {scorerResult.improvements.map((imp, i) => (
              <li key={i} className="improvement-item">
                <div className="suggestion">{typeof imp === 'string' ? imp : imp.suggestion}</div>
                {imp.reason && <div className="reason">Why: {imp.reason}</div>}
                
                {imp.original_sentence && (
                  <div className="rewrite-container">
                    <div className="before-box">
                      <strong>Original:</strong>
                      <p>"{imp.original_sentence}"</p>
                    </div>
                    <div className="after-box">
                      <strong>Suggested Rewrite:</strong>
                      <p>"{imp.rewrite_example}"</p>
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {scorerResult.career_paths && (
        <div className="career-paths">
          <h4><Rocket size={20} style={{ verticalAlign: 'middle', marginRight: '8px' }} /> Career Paths</h4>
          <div className="path-chips">
            {scorerResult.career_paths.map((p, i) => (
              <span key={i} className="path-chip">{p}</span>
            ))}
          </div>
        </div>
      )}
      
      <button 
        className="submit-btn" 
        onClick={() => setScorerResult(null)} 
        style={{ display: 'block', margin: '2rem auto 0 auto', maxWidth: '300px' }}
      >
        Score Another Resume
      </button>
    </div>
  );
};

export default ResumeScorerResults;
